import { WithDefaultLayout } from "../components/DefautLayout";
import { Title } from "../components/Title";
import { Page } from "../types/Page";
import CompanyProfileSlider from "../components/CompanySlider";

const AboutUs: Page = () => {
  return (
    <div>
      <Title
        title={"Tentang Kami"}
        description="Sejarah kami berkontribusi dalam industri IT, dan membangun talenta digital."
      />
      <div>
        {/* Tentang Kami */}
        <section className="py-8 sm:py-12 px-4 md:px-8 flex flex-col md:flex-row bg-white">
          <div className="w-full max-w-6xl mx-auto flex flex-wrap">
            <div className="w-full self-center px-2 md:w-1/2">
            <h2 className="text-2xl md:text-3xl lg:text-[28px] text-accelist-green mb-8 font-semibold">
                Tentang Kami
            </h2>
            <h3 className="text-2xl md:text-3xl lg:text-5xl text-secondary-100 font-body font-bold mb-4 whitespace-nowrap">
                Accelist Edukasi Indonesia
            </h3>
            <p className="text-base md:text-lg lg:text-xl text-secondary-100 font-medium mb-4 text-justify leading-relaxed">
                Accelist Edukasi Indonesia merupakan bagian dari Accelist Lentera Indonesia yang sudah berdiri sejak tahun 2012.
            </p>
            <p className="text-base md:text-lg lg:text-xl text-secondary-100 font-medium mb-4 text-justify leading-relaxed">
                Sebagai wadah transformasi digital masyarakat Indonesia, Accelist telah menciptakan talenta digital dengan kualitas terbaik sejumlah 200+ 
                melalui 7 batch training sejak tahun 2017 hingga saat ini.
            </p>
            <p className="text-base md:text-lg lg:text-xl text-secondary-100 font-medium mb-4 text-justify leading-relaxed">
                Accelist juga turut merekrut 50 lulusan terbaik untuk menjadi bagian dari keluarga kami sebagai bentuk kontribusi dalam mengakselerasi transformasi digital di Indonesia.
            </p>
            </div>
            <div className="md:w-1/2 mt-8 md:mt-0 md:pl-16 lg:pl-20 relative z-10">
              <div className="relative w-full">
              <img
                src="img/tentangkami/tentang-kami-landing-page-baru.png"
                alt="img"
                className="hidden md:block w-full mx-auto relative z-10"
              />
              <img
                src="img/tentangkami/lampu.png"
                alt="lampu"
                className="hidden md:block absolute top-[-5%] left-[10%] w-[8vw] max-w-[120px] h-auto"
              />
              <img
                src="img/tentangkami/titik.png"
                alt="titik"
                className="hidden md:block absolute top-[45%] left-[8%] w-[8vw] max-w-[100px] h-auto"
              />
              <img
                src="img/tentangkami/silang.png"
                alt="silang"
                className="hidden md:block absolute top-[20%] left-[85%] w-[8vw] max-w-[100px] h-auto"
              />
              <img
                src="img/tentangkami/panah-atas.png"
                alt="panah atas"
                className="hidden md:block absolute bottom-[-11%] right-[-15%] w-[8vw] max-w-[65px] h-auto"
              />
              </div>
            </div>
          </div>
        </section>
        

        {/* Sejarah Accelist */}
        <section className="bg-about-us py-10 md:py-12 px-4 md:px-8">
          <div className="w-full max-w-6xl mx-auto flex flex-wrap">
            <div className="w-full self-center px-2 md:w-1/2">
              <p className="text-2xl md:text-3xl lg:text-[40px] text-accent-100 font-bold leading-snug md:leading-relaxed mb-6">
                Sejarah Accelist
              </p>
              <p className="text-white text-base md:text-lg lg:text-xl font-medium leading-relaxed mb-4 text-justify">
                Didirikan pada tanggal 3 Agustus 2012, Accelist memiliki visi
                untuk menjadi perusahaan yang cepat beradaptasi dalam menjawab kebutuhan dan
                permintaan di berbagai industri.
              </p>
              <br />
              <p className="text-white text-base md:text-lg lg:text-xl font-medium leading-relaxed mb-4 text-justify">
                Misi kami adalah untuk mempercepat Sistem Informasi dan
                Teknologi Anda.
              </p>
              <br />
              <p className="text-white text-base md:text-lg lg:text-xl font-medium leading-relaxed text-justify">
                Kami percaya bahwa di masa depan, kebutuhan bisnis modern akan
                Sistem Informasi dan Teknologi harus dipenuhi dengan cepat,
                fleksibel, dan hemat biaya.
              </p>
            </div>
            <div className="md:w-1/2 z-10 mt-8 md:mt-0 md:pl-8"> 
                <img
                  src="img/tentangkami/Accelist.png"
                  alt="aboutus.png"
                  className="w-full max-w-[500px] md:max-w-[512px] aspect-[551/460] mx-auto object-contain"
                />
            </div>
          </div>
        </section>

        {/* Apa itu Accelist */}
    
        <section className="pt-12 md:pt-16 mb-6 md:mb-0">
          <div className="w-full max-w-6xl mx-auto px-4 md:px-6 flex flex-col-reverse md:flex-row items-center gap-12 md:gap-16">
            <div className="w-full md:w-1/2 flex self-center">
            <img
              src="img/tentangkami/apa-itu-accelist.png"
              alt="img"
              className="w-full max-w-[512px] md:max-w-[480px] object-contain aspect-[512/495]"
            />
            </div>
            <div className="w-full md:w-1/2">
            <p className="text-2xl md:text-3xl lg:text-4xl text-accent-100 font-body font-bold mb-4 md:mb-8">
              Apa itu Accelist?
            </p>
            <p className="text-base md:text-lg lg:text-xl text-secondary-100 font-medium leading-relaxed text-justify">
            Dengan pengalaman lebih dari 15 tahun dari para pendiri di industri Teknologi Informasi, kami telah terlibat dalam banyak proyek implementasi IT. Mulai dari implementasi aplikasi ERP terkemuka hingga pengembangan berbagai aplikasi di berbagai platform, yaitu web, desktop, dan aplikasi mobile.
            Kami juga memperluas cakrawala bisnis kami ke industri penerbangan sebagai distributor peralatan, suku cadang dan perkakas, serta menyediakan layanan pemeliharaan kepada pelanggan kami.
            </p>
            </div>
          </div>
        </section>
        
        {/* Visi Misi */}
        <section className="flex flex-wrap justify-center bg-white mb-8">
        <div className="mt-10 flex flex-col md:flex-row gap-5 justify-center items-center">
          <div className="flex flex-col md:flex-row bg-white border-2 border-black gap-5 text-black p-6 md:p-10 rounded-sm drop-shadow-lg justify-center items-center w-full md:w-[580px] min-h-[200px]">
            <img
              src="img/tentangkami/visi.png"
              alt="Icon"
              className="h-24 w-24 mb-4 sm:mb-0"
            />
            <div className="sm:mx-8 text-accelist-font text-justify sm:text-left w-full whitespace-nowrap">
              <p className="text-xl mb-4 text-center text-black">Visi</p>
              <p className="text-base md:text-lg text-black font-body font-medium text-center">
                Menjadi perusahaan pilihan utama <br/> 
                masyarakat indonesia dalam penyediaan <br/>
                ilmu untuk solusi bisnis dan digitalisasi.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row bg-white border-2 border-black gap-5 text-black p-8 sm:p-10 rounded-sm drop-shadow-lg justify-center items-center w-full md:w-[580px] min-h-[200px]">
            <img
              src="img/tentangkami/misi.png"
              alt="Icon"
              className="h-24 w-24 mb-4 sm:mb-0"
            />
            <div className="sm:mx-8 text-accelist-font text-justify sm:text-left w-full whitespace-nowrap">
              <p className="text-xl mb-4 text-center">Misi</p>
              <p className="text-base md:text-lg text-black font-body font-medium text-center">
                Menyediakan wadah untuk mengeksplorasi<br />
                dan membangun skill para talenta digital<br />
                yang berkompeten.
              </p>
            </div>
          </div>
        </div>
        </section>

        <CompanyProfileSlider />
      </div>
    </div>
  );
};

AboutUs.layout = WithDefaultLayout;
export default AboutUs;
